module.exports = __webpack_public_path__ + "static/middle-header-a4349473284ebdcf99a10727c4c9ee3f.jpg";